import { render, staticRenderFns } from "./MenuUsuario.vue?vue&type=template&id=25dfecb4&"
import script from "./MenuUsuario.vue?vue&type=script&lang=js&"
export * from "./MenuUsuario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports